import type { FEATURE_OPTIONS } from '@/constants/api/governmentSetting/featureOptions'

/** 自治体設定API(query)のリクエスト */
export interface ArgQueryGovernmentSettings {
  system: string
  govCode: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArgQueryGovernmentSettings = (arg: any): boolean => {
  return (
    arg !== null &&
    typeof arg === 'object' &&
    typeof arg.system === 'string' &&
    typeof arg.govCode === 'string'
  )
}

/** 自治体設定API(query)のレスポンス */
export interface ResQueryGovernmentSettings {
  system: string
  govCode: string
  initialMapLocation: number[]
  upperLimitQuantityOfInspection?: number
  serviceLimitEnable?: boolean
  manualUrl?: string
  isDeviceAuthentication: boolean // 【デバイス認証】
  featureOptions: FeatureOptions[]
}

export interface resQueryGovernment {
  result: ResQueryGovernmentSettings
}

export type FeatureOptions = (typeof FEATURE_OPTIONS)[keyof typeof FEATURE_OPTIONS]
